import { Component, Input} from '@angular/core';


/**
   * Logger Factory
   * @namespace title: tile to show
   * @namespace date: is the date to show
   * <ute-avatar class="image"  image="..." isEditable="true"></ute-avatar>
*/

@Component({
  selector: 'ute-activity-small-item',
  templateUrl: 'ute-activity-small-item.component.html',
})
export class UteActivitySmallItem {
  @Input() title: string;
  @Input() date: string;

  constructor() {
  
  }

  ngOnInit(){
  
  }

}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-activity-small-item/ute-activity-small-item.component.ts